function applyMembershipDiscounts() {
    // Define the discount percentages, labels, and classes
    const discounts = [
        { label: 'Bronze', percentage: 0.10, class: 'bronze' },
        { label: 'Silver', percentage: 0.12, class: 'silver' },
        { label: 'Gold', percentage: 0.15, class: 'gold' }
    ];

    // Select elements with sale or regular prices
    const priceElements = document.querySelectorAll('.m-price-reg, .m-price-sale');
    const membershipPricesContainers = document.querySelectorAll('.membership-prices');

    if (priceElements.length === 0 || membershipPricesContainers.length === 0) {
        console.warn('No price or membership price elements found on the page.');
        return;
    }

    priceElements.forEach((priceElement, index) => {
        const priceText = priceElement.textContent.trim();

        // Detect the currency symbol from the displayed product price
        const currencyMatch = priceText.match(/[^\d\s.,]+/);
        const currencySymbol = currencyMatch ? currencyMatch[0] : '£';

        // Remove currency symbols/spaces but keep decimal separators
        let numericPrice = priceText.replace(/[^\d.,]/g, '');

        const lastComma = numericPrice.lastIndexOf(',');
        const lastDot = numericPrice.lastIndexOf('.');

        // Work out whether comma or dot is being used as the decimal separator
        if (lastComma > lastDot) {
            // Example: €1.234,56 → 1234.56
            numericPrice = numericPrice.replace(/\./g, '').replace(',', '.');
        } else {
            // Example: £1,234.56 → 1234.56
            numericPrice = numericPrice.replace(/,/g, '');
        }

        const originalPrice = parseFloat(numericPrice);

        if (isNaN(originalPrice)) {
            console.warn('Invalid price:', priceText);
            return;
        }

        // Check whether the displayed currency uses a comma decimal
        const usesCommaDecimal = /,\d{2}/.test(priceText);

        const membershipPricesContainer =
            membershipPricesContainers[index % membershipPricesContainers.length];

        membershipPricesContainer.innerHTML = '';

        discounts.forEach(discount => {
            let discountedPrice = (originalPrice * (1 - discount.percentage)).toFixed(2);

            // Match the decimal formatting of the original price
            if (usesCommaDecimal) {
                discountedPrice = discountedPrice.replace('.', ',');
            }

            const discountElement = document.createElement('span');
            discountElement.classList.add(discount.class);

            discountElement.innerHTML = `
                <div class="m-prices-wrap">
                    <span class="m-percentage">${discount.percentage * 100}%</span>
                    <span class="m-price">${currencySymbol}${discountedPrice}</span>
                </div>
            `;

            membershipPricesContainer.appendChild(discountElement);
        });
    });
}

// Run the function on page load
document.addEventListener('DOMContentLoaded', applyMembershipDiscounts);
window.onload = applyMembershipDiscounts;